<template>
  <div>
    <div class="ban-p">
      <img v-if="result && result.headerImg" :src="imageUrl + result.headerImg" />
    </div>
    <div class="g-snva1">
      <div class="wp">
        <subnav :type="2"></subnav>
      </div>
    </div>
    <div class="wp introduce">
      <ul class="ul-teamlist" v-if="teamRes && teamRes.records">
        <li v-for="item of teamRes.records" :key="item.id">
          <div
            class="con"
            @mouseover="showPop(item.mangerIcon, item.mangerDesc)"
            @mouseout="clearTimer"
          >
            <div class="up">
              <div class="pic">
                <div
                  class="img"
                  :style="
                    'background-image: url(' + '\'' + imageUrl + item.mangerIcon + '\'' + ');'
                  "
                ></div>
              </div>
              <div class="txt">
                <div class="name" style="font-weight: bolder; color: gray">
                  {{ item.mangerName }}
                </div>
                <div class="ma" style="font-weight: bolder; color: gray">{{ item.mangerPos }}</div>
              </div>
            </div>
            <div class="oth">
              <div class="desc">
                {{ item.remarks }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="pages" v-if="total && total > size">
        <ul>
          <li class="prev" :class="[curPage == 1 ? 'hide' : '']">
            <span @click="prevPage">&lt;</span>
          </li>
          <li
            :class="[curPage == index + 1 ? 'on' : '']"
            v-for="(item, index) of pages"
            :key="index"
          >
            <span @click="navToPage(index + 1)">{{ index + 1 }}</span>
          </li>
          <li class="next" :class="[curPage == pages ? 'hide' : '']">
            <span @click="nextPage">&gt;</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 团队弹窗 -->
    <div class="m-pop" v-if="popShow">
      <div class="pop-bg"></div>
      <div class="inner">
        <span class="close" @click="closePop"></span>
        <div class="m-userinfob1">
          <div class="pic">
            <img :src="imageUrl + detailsImg" alt="" />
          </div>
          <div class="txt">
            <template v-for="(item, index) of detailsTxt">
              <p :key="index" v-if="item">{{ item }}</p>
              <p :key="'p1' + index" v-if="item"><br /></p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
var timer = null //鼠标悬浮定时器
import subnav from '@/components/subnav'
export default {
  components: {
    subnav
  },
  data() {
    return {
      loading: true,
      result: null,
      teamRes: {},

      popShow: false,
      detailsTxt: '',
      detailsImg: '',

      pages: '',
      size: '',
      curPage: '',
      total: '',

      pageInfo: {
        zhId: '1436237936873328641',
        enId: '1436237899229450242'
      }
    }
  },
  mounted() {
    let that = this
    /* let lang = localStorage.getItem("locale") || 'zh';
    that.lang = lang;
    that.$i18n.locale = lang; */
    Loading.service()
    /* if (that.$i18n.locale === 'zh') {
      that.getTeam(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getTeam(that.pageInfo.enId);
    } */
    that.getTeam(that.pageInfo.enId)
  },
  /* watch: {
    '$i18n.locale' (newValue) {
      Loading.service();
      if (this.$i18n.locale === 'zh') {
        this.getTeam(this.pageInfo.zhId);
      } else if (this.$i18n.locale === 'en') {
        this.getTeam(this.pageInfo.enId);
      }
    }
  }, */
  methods: {
    // 团队弹窗
    showPop(img, txt) {
      let that = this
      that.detailsImg = ''
      that.detailsTxt = ''
      that.popShow = false

      if (document.body.clientWidth > 1200) {
        timer = setTimeout(() => {
          that.detailsImg = img
          that.detailsTxt = txt ? txt.split('\n') : []
          that.popShow = true
        }, 1000)
      } else {
        that.detailsImg = img
        that.detailsTxt = txt ? txt.split('\n') : []
        that.popShow = true
      }
    },
    clearTimer() {
      clearTimeout(timer)
      timer = null
    },
    closePop() {
      let that = this
      that.clearTimer()
      that.detailsImg = ''
      that.detailsTxt = ''
      that.popShow = false
    },
    // 获取团队信息
    getTeam(id) {
      let that = this
      let data = {
        id: id
      }
      that.$http
        .getTeam(data)
        .then(res => {
          if (res.code == 200) {
            let result = res.result
            that.result = result
            let dataConfigs = JSON.parse(result.dataConfigs).configs[0]
            that.url = dataConfigs.path
            that.langKey = dataConfigs.params.langKey
            that.getList()
          }
        })
        .catch(err => {
          that.$message({
            message: err,
            type: 'error'
          })
        })
    },
    // 获取团队列表
    getList(page) {
      Loading.service()
      let that = this
      that.$axios
        .get(that.url, {
          params: {
            langKey: that.langKey,
            pageNo: page || 1,
            column: 'orderNum',
            order: 'desc'
          }
        })
        .then(function (res) {
          if (res.status == 200) {
            that.teamRes = res.data.result
            Loading.service().close()
            that.pages = res.data.result.pages
            that.curPage = res.data.result.current
            that.total = res.data.result.total
            that.size = res.data.result.size
          }
        })
        .catch(function (err) {
          that.$message({
            message: err,
            type: 'error'
          })
        })
    },

    navToPage(page) {
      let that = this
      that.curPage = page
      that.getList(page)
    },
    prevPage() {
      let that = this
      let prevPage = that.curPage - 1
      that.curPage = prevPage
      if (prevPage < 1) {
        prevPage = 1
        that.curPage = 1
        return false
      }
      that.getList(prevPage)
    },
    nextPage() {
      let that = this
      let nextPage = that.curPage + 1
      that.curPage = nextPage
      if (nextPage > that.pages) {
        nextPage = that.pages
        that.curPage = that.pages
        return false
      }
      that.getList(nextPage)
    }
  }
}
</script>

<style scoped>
.ul-teamlist .con .ma {
  white-space: unset;
  overflow: unset;
}
</style>
